import React from 'react';
import kebabCase from 'lodash.kebabcase';
import { ClickOrPressEvent } from 'types/mouseEvents';

import { ReactComponent as Adjust } from 'assets/icons/adjust.svg';
import { ReactComponent as AlertCircle } from 'assets/icons/alert-circle.svg';
import { ReactComponent as ArrowDownCircle } from 'assets/icons/arrow-down-circle.svg';
import { ReactComponent as ArrowDown } from 'assets/icons/arrow-down.svg';
import { ReactComponent as ArrowLeftCircle } from 'assets/icons/arrow-left-circle.svg';
import { ReactComponent as ArrowLeft } from 'assets/icons/arrow-left.svg';
import { ReactComponent as ArrowRightCircle } from 'assets/icons/arrow-right-circle.svg';
import { ReactComponent as ArrowRight } from 'assets/icons/arrow-right.svg';
import { ReactComponent as ArrowUpCircle } from 'assets/icons/arrow-up-circle.svg';
import { ReactComponent as ArrowUp } from 'assets/icons/arrow-up.svg';
import { ReactComponent as At } from 'assets/icons/at.svg';
import { ReactComponent as BankCard } from 'assets/icons/bank-card.svg';
import { ReactComponent as Bank } from 'assets/icons/bank.svg';
import { ReactComponent as Banknote } from 'assets/icons/banknote.svg';
import { ReactComponent as BathBasic } from 'assets/icons/bath.svg';
import { ReactComponent as BedBasic } from 'assets/icons/bed.svg';
import { ReactComponent as Bell } from 'assets/icons/bell.svg';
import { ReactComponent as Bookmark } from 'assets/icons/bookmark.svg';
import { ReactComponent as Calendar } from 'assets/icons/calendar.svg';
import { ReactComponent as Camera } from 'assets/icons/camera.svg';
import { ReactComponent as CarBasic } from 'assets/icons/car.svg';
import { ReactComponent as ChatText } from 'assets/icons/chat-text.svg';
import { ReactComponent as CheckCircle } from 'assets/icons/check-circle.svg';
import { ReactComponent as ChevronDoubleDown } from 'assets/icons/chevron-double-down.svg';
import { ReactComponent as ChevronDoubleLeft } from 'assets/icons/chevron-double-left.svg';
import { ReactComponent as ChevronDoubleRight } from 'assets/icons/chevron-double-right.svg';
import { ReactComponent as ChevronDoubleUp } from 'assets/icons/chevron-double-up.svg';
import { ReactComponent as ChevronDownCircle } from 'assets/icons/chevron-down-circle.svg';
import { ReactComponent as ChevronDown } from 'assets/icons/chevron-down.svg';
import { ReactComponent as ChevronLeftCircle } from 'assets/icons/chevron-left-circle.svg';
import { ReactComponent as ChevronLeft } from 'assets/icons/chevron-left.svg';
import { ReactComponent as ChevronRightCircle } from 'assets/icons/chevron-right-circle.svg';
import { ReactComponent as ChevronRight } from 'assets/icons/chevron-right.svg';
import { ReactComponent as ChevronUpCircle } from 'assets/icons/chevron-up-circle.svg';
import { ReactComponent as ChevronUp } from 'assets/icons/chevron-up.svg';
import { ReactComponent as CircleFilled } from 'assets/icons/circle-filled.svg';
import { ReactComponent as Circle } from 'assets/icons/circle.svg';
import { ReactComponent as Close } from 'assets/icons/close.svg';
import { ReactComponent as Clock } from 'assets/icons/clock.svg';
import { ReactComponent as CoinDollar } from 'assets/icons/coin-dollar.svg';
import { ReactComponent as Edit } from 'assets/icons/edit.svg';
import { ReactComponent as Export } from 'assets/icons/export.svg';
import { ReactComponent as ExternalLink } from 'assets/icons/external-link.svg';
import { ReactComponent as Eye } from 'assets/icons/eye.svg';
import { ReactComponent as Facebook } from 'assets/icons/facebook.svg';
import { ReactComponent as FileDownload } from 'assets/icons/file-download.svg';
import { ReactComponent as File } from 'assets/icons/file.svg';
import { ReactComponent as Filter } from 'assets/icons/filter.svg';
import { ReactComponent as FolderArchive } from 'assets/icons/folder-archive.svg';
import { ReactComponent as Folder } from 'assets/icons/folder.svg';
import { ReactComponent as Globe } from 'assets/icons/globe.svg';
import { ReactComponent as Heart } from 'assets/icons/heart.svg';
import { ReactComponent as Home } from 'assets/icons/home.svg';
import { ReactComponent as Image } from 'assets/icons/image.svg';
import { ReactComponent as Import } from 'assets/icons/import.svg';
import { ReactComponent as Info } from 'assets/icons/info.svg';
import { ReactComponent as Instagram } from 'assets/icons/instagram.svg';
import { ReactComponent as Laptop } from 'assets/icons/laptop.svg';
import { ReactComponent as LightBulb } from 'assets/icons/light-bulb.svg';
import { ReactComponent as LineUp } from 'assets/icons/line-up.svg';
import { ReactComponent as Linkedin } from 'assets/icons/linkedin.svg';
import { ReactComponent as List } from 'assets/icons/list.svg';
import { ReactComponent as Location } from 'assets/icons/location.svg';
import { ReactComponent as LockOpen } from 'assets/icons/lock-open.svg';
import { ReactComponent as Lock } from 'assets/icons/lock.svg';
import { ReactComponent as Login } from 'assets/icons/login.svg';
import { ReactComponent as Logout } from 'assets/icons/logout.svg';
import { ReactComponent as Mail } from 'assets/icons/mail.svg';
import { ReactComponent as Map } from 'assets/icons/map.svg';
import { ReactComponent as MapPin } from 'assets/icons/map-pin.svg';
import { ReactComponent as Maximize } from 'assets/icons/maximize.svg';
import { ReactComponent as Maximize2 } from 'assets/icons/maximize-2.svg';
import { ReactComponent as Megaphone } from 'assets/icons/megaphone.svg';
import { ReactComponent as Menu } from 'assets/icons/menu.svg';
import { ReactComponent as Minus } from 'assets/icons/minus.svg';
import { ReactComponent as Mobile } from 'assets/icons/mobile.svg';
import { ReactComponent as More } from 'assets/icons/more.svg';
import { ReactComponent as MessageSqaure } from 'assets/icons/message-square.svg';
import { ReactComponent as Pause } from 'assets/icons/pause.svg';
import { ReactComponent as Phone } from 'assets/icons/phone.svg';
import { ReactComponent as Pinterest } from 'assets/icons/pinterest.svg';
import { ReactComponent as PlayCircle } from 'assets/icons/play-circle.svg';
import { ReactComponent as PlayDuotone } from 'assets/icons/play-duotone.svg';
import { ReactComponent as Play } from 'assets/icons/play.svg';
import { ReactComponent as Plus } from 'assets/icons/plus.svg';
import { ReactComponent as QuestionMark } from 'assets/icons/question-mark.svg';
import { ReactComponent as Remove } from 'assets/icons/remove.svg';
import { ReactComponent as RoundOutline } from 'assets/icons/round-outline.svg';
import { ReactComponent as RoundSolid } from 'assets/icons/round-solid.svg';
import { ReactComponent as Search } from 'assets/icons/search.svg';
import { ReactComponent as Send } from 'assets/icons/send.svg';
import { ReactComponent as SettingsAdjust } from 'assets/icons/settings-adjust.svg';
import { ReactComponent as Settings } from 'assets/icons/settings.svg';
import { ReactComponent as Share } from 'assets/icons/share.svg';
import { ReactComponent as ShoppingCart } from 'assets/icons/shopping-cart.svg';
import { ReactComponent as SquareChecked } from 'assets/icons/square-checked.svg';
import { ReactComponent as Square } from 'assets/icons/square.svg';
import { ReactComponent as Star } from 'assets/icons/star.svg';
import { ReactComponent as Time } from 'assets/icons/time.svg';
import { ReactComponent as TrashCan } from 'assets/icons/trash-can.svg';
import { ReactComponent as Trophy } from 'assets/icons/trophy.svg';
import { ReactComponent as Twitter } from 'assets/icons/twitter.svg';
import { ReactComponent as UserCircle } from 'assets/icons/user-circle.svg';
import { ReactComponent as User } from 'assets/icons/user.svg';
import { ReactComponent as Warning } from 'assets/icons/warning.svg';
import { ReactComponent as XCircle } from 'assets/icons/x-circle.svg';
import { ReactComponent as X } from 'assets/icons/x.svg';
import { ReactComponent as Youtube } from 'assets/icons/youtube.svg';
import { ReactComponent as Floorplan } from 'assets/icons/floorplan.svg';

// Brand Icons
import { ReactComponent as AgreementSign } from 'assets/icons/brand-icons/agreement-sign.svg';
import { ReactComponent as Aircon } from 'assets/icons/brand-icons/aircon.svg';
import { ReactComponent as ArtAndCraftBrushes } from 'assets/icons/brand-icons/art-and-craft-brushes.svg';
import { ReactComponent as ArtAndCraftCanvas } from 'assets/icons/brand-icons/art-and-craft-canvas.svg';
import { ReactComponent as Balcony } from 'assets/icons/brand-icons/balcony.svg';
import { ReactComponent as Bath } from 'assets/icons/brand-icons/bath.svg';
import { ReactComponent as Bbq } from 'assets/icons/brand-icons/bbq.svg';
import { ReactComponent as Bed } from 'assets/icons/brand-icons/bed.svg';
import { ReactComponent as BilliardsGamesroom } from 'assets/icons/brand-icons/billiards-gamesroom.svg';
import { ReactComponent as Binoculars } from 'assets/icons/brand-icons/binoculars.svg';
import { ReactComponent as CampCaravan } from 'assets/icons/brand-icons/camp-caravan.svg';
import { ReactComponent as CampingTent } from 'assets/icons/brand-icons/camping-tent.svg';
import { ReactComponent as Car } from 'assets/icons/brand-icons/car.svg';
import { ReactComponent as CarerFosterKindship } from 'assets/icons/brand-icons/carer-foster-kindship.svg';
import { ReactComponent as CarspaceCarport } from 'assets/icons/brand-icons/carspace-carport.svg';
import { ReactComponent as Chair } from 'assets/icons/brand-icons/chair.svg';
import { ReactComponent as ChurchCandles } from 'assets/icons/brand-icons/church-candles.svg';
import { ReactComponent as CleaningAndLaundry } from 'assets/icons/brand-icons/cleaning-and-laundry.svg';
import { ReactComponent as CommunityLargeHouse } from 'assets/icons/brand-icons/community-large-house.svg';
import { ReactComponent as DayTripsBusCoach } from 'assets/icons/brand-icons/day-trips-bus-coach.svg';
import { ReactComponent as DementiaCareBrainHeart } from 'assets/icons/brand-icons/dementia-care-brain-heart.svg';
import { ReactComponent as DirectionSigns } from 'assets/icons/brand-icons/direction-signs.svg';
import { ReactComponent as Distance85km } from 'assets/icons/brand-icons/distance-85-km.svg';
import { ReactComponent as DoctorStethoscope } from 'assets/icons/brand-icons/doctor-stethoscope.svg';
import { ReactComponent as EarlyLearningServices } from 'assets/icons/brand-icons/early-learning-services.svg';
import { ReactComponent as EmployeesBadge } from 'assets/icons/brand-icons/employees-badge.svg';
import { ReactComponent as EstablishedGardensFlower } from 'assets/icons/brand-icons/established-gardens-flower.svg';
import { ReactComponent as ExerciseWeight } from 'assets/icons/brand-icons/exercise-weight.svg';
import { ReactComponent as FamilyCare } from 'assets/icons/brand-icons/family-care.svg';
import { ReactComponent as FamilyDaycare } from 'assets/icons/brand-icons/family-daycare.svg';
import { ReactComponent as FamilySupportUmbrella } from 'assets/icons/brand-icons/family-support-umbrella.svg';
import { ReactComponent as FishingLineFish } from 'assets/icons/brand-icons/fishing-line-fish.svg';
import { ReactComponent as GarageHouse } from 'assets/icons/brand-icons/garage-house.svg';
import { ReactComponent as GardenMaintenanceMower } from 'assets/icons/brand-icons/garden-maintenance-mower.svg';
import { ReactComponent as GardenModificationsPotShovel } from 'assets/icons/brand-icons/garden-modifications-pot-shovel.svg';
import { ReactComponent as GolfCart } from 'assets/icons/brand-icons/golf-cart.svg';
import { ReactComponent as GolfFlag } from 'assets/icons/brand-icons/golf-flag.svg';
import { ReactComponent as Government } from 'assets/icons/brand-icons/government.svg';
import { ReactComponent as GroceryGeneralShopping } from 'assets/icons/brand-icons/grocery-general-shopping.svg';
import { ReactComponent as HairSalonScissorsComb } from 'assets/icons/brand-icons/hair-salon-scissors-comb.svg';
import { ReactComponent as HeartsFamilySupport } from 'assets/icons/brand-icons/hearts-family-support.svg';
import { ReactComponent as HeatingSun } from 'assets/icons/brand-icons/heating-sun.svg';
import { ReactComponent as HomeCareMopBucket } from 'assets/icons/brand-icons/home-care-mop-bucket.svg';
import { ReactComponent as HomeMaintenanceTools } from 'assets/icons/brand-icons/home-maintenance-tools.svg';
import { ReactComponent as HomeModifications } from 'assets/icons/brand-icons/home-modifications.svg';
import { ReactComponent as HomeServicesCleaning } from 'assets/icons/brand-icons/home-services-cleaning.svg';
import { ReactComponent as HousekeepingCleanMopBucket } from 'assets/icons/brand-icons/housekeeping-clean-mop-bucket.svg';
import { ReactComponent as HousingServicesWelcome } from 'assets/icons/brand-icons/housing-services-welcome.svg';
import { ReactComponent as InHomeCare } from 'assets/icons/brand-icons/in-home-care.svg';
import { ReactComponent as IndustryBodiesCogs } from 'assets/icons/brand-icons/industry-bodies-cogs.svg';
import { ReactComponent as InvestorsGraph } from 'assets/icons/brand-icons/investors-graph.svg';
import { ReactComponent as JourneyPath } from 'assets/icons/brand-icons/journey-path.svg';
import { ReactComponent as Kitchen } from 'assets/icons/brand-icons/kitchen.svg';
import { ReactComponent as LaundryCustom } from 'assets/icons/brand-icons/laundry-custom.svg';
import { ReactComponent as LaundryWashingMachine } from 'assets/icons/brand-icons/laundry-washing-machine.svg';
import { ReactComponent as LibraryBooks } from 'assets/icons/brand-icons/library-books.svg';
import { ReactComponent as LocalGovernment } from 'assets/icons/brand-icons/local-government.svg';
import { ReactComponent as LockupStorageLock } from 'assets/icons/brand-icons/lockup-storage-lock.svg';
import { ReactComponent as MaintenanceServices } from 'assets/icons/brand-icons/maintenance-services.svg';
import { ReactComponent as MaleFemaleSymbols } from 'assets/icons/brand-icons/male-female-symbols.svg';
import { ReactComponent as ManageFinancesChecklist } from 'assets/icons/brand-icons/manage-finances-checklist.svg';
import { ReactComponent as MealPrepChoppingBoard } from 'assets/icons/brand-icons/meal-prep-chopping-board.svg';
import { ReactComponent as MealsProvidedKlosh } from 'assets/icons/brand-icons/meals-provided-klosh.svg';
import { ReactComponent as MealsProvidedPlate } from 'assets/icons/brand-icons/meals-provided-plate.svg';
import { ReactComponent as MedicalCareMedicalKitDoctor } from 'assets/icons/brand-icons/medical-care-medical-kit-doctor.svg';
import { ReactComponent as MotocrossTrackRaceTrack } from 'assets/icons/brand-icons/motocross-track-race-track.svg';
import { ReactComponent as MultipleHomes } from 'assets/icons/brand-icons/multiple-homes.svg';
import { ReactComponent as NextStepShoe } from 'assets/icons/brand-icons/next-step-shoe.svg';
import { ReactComponent as OverseasAeroplane } from 'assets/icons/brand-icons/overseas-aeroplane.svg';
import { ReactComponent as PalliativeCare } from 'assets/icons/brand-icons/palliative-care.svg';
import { ReactComponent as ParkTrees } from 'assets/icons/brand-icons/park-trees.svg';
import { ReactComponent as PastoralSupportChurch } from 'assets/icons/brand-icons/pastoral-support-church.svg';
import { ReactComponent as PetFriendlyAnimals } from 'assets/icons/brand-icons/pet-friendly-animals.svg';
import { ReactComponent as PicnicBasket } from 'assets/icons/brand-icons/picnic-basket.svg';
import { ReactComponent as PoolSwim } from 'assets/icons/brand-icons/pool-swim.svg';
import { ReactComponent as PrivateSectorApartment } from 'assets/icons/brand-icons/private-sector-apartment.svg';
import { ReactComponent as PropertyInspection } from 'assets/icons/brand-icons/property-inspection.svg';
import { ReactComponent as RegisteredNurse } from 'assets/icons/brand-icons/registered-nurse.svg';
import { ReactComponent as RenovatedPaintRoller } from 'assets/icons/brand-icons/renovated-paint-roller.svg';
import { ReactComponent as ResidentialCareHome } from 'assets/icons/brand-icons/residential-care-home.svg';
import { ReactComponent as ResidentialSlippers } from 'assets/icons/brand-icons/residential-slippers.svg';
import { ReactComponent as RespiteCareTeaHeart } from 'assets/icons/brand-icons/respite-care-tea-heart.svg';
import { ReactComponent as RespiteCareTea } from 'assets/icons/brand-icons/respite-care-tea.svg';
import { ReactComponent as Services500Plus } from 'assets/icons/brand-icons/services-500-plus.svg';
import { ReactComponent as ShoppingBags } from 'assets/icons/brand-icons/shopping-bags.svg';
import { ReactComponent as SocialConnections } from 'assets/icons/brand-icons/social-connections.svg';
import { ReactComponent as SpaciousFloorplan } from 'assets/icons/brand-icons/spacious-floorplan.svg';
import { ReactComponent as StakeholdersEngagement } from 'assets/icons/brand-icons/stakeholders-engagement.svg';
import { ReactComponent as SupportAndDevelopment } from 'assets/icons/brand-icons/support-and-development.svg';
import { ReactComponent as TelephonePointPhone } from 'assets/icons/brand-icons/telephone-point-phone.svg';
import { ReactComponent as ThrivingCommunity } from 'assets/icons/brand-icons/thriving-community.svg';
import { ReactComponent as TimeClock } from 'assets/icons/brand-icons/time-clock.svg';
import { ReactComponent as VeggieGardenPlantShovel } from 'assets/icons/brand-icons/veggie-garden-plant-shovel.svg';
import { ReactComponent as Wardrobe } from 'assets/icons/brand-icons/wardrobe.svg';
import { ReactComponent as Windows } from 'assets/icons/brand-icons/windows.svg';
import { ReactComponent as WineGlass } from 'assets/icons/brand-icons/wine-glass.svg';
import { ReactComponent as YouthLegoBricks } from 'assets/icons/brand-icons/youth-lego-bricks.svg';
import { ReactComponent as OpenedMail } from 'assets/icons/brand-icons/opened-mail.svg';

export type IconString =
    | 'adjust'
    | 'alert-circle'
    | 'arrow-down-circle'
    | 'arrow-down'
    | 'arrow-left-circle'
    | 'arrow-left'
    | 'arrow-right-circle'
    | 'arrow-right'
    | 'arrow-up-circle'
    | 'arrow-up'
    | 'at'
    | 'bank-card'
    | 'bank'
    | 'banknote'
    | 'bath'
    | 'bell'
    | 'bed'
    | 'bookmark'
    | 'calendar'
    | 'camera'
    | 'car'
    | 'chat-text'
    | 'check-circle'
    | 'chevron-double-down'
    | 'chevron-double-left'
    | 'chevron-double-right'
    | 'chevron-double-up'
    | 'chevron-down-circle'
    | 'chevron-down'
    | 'chevron-left-circle'
    | 'chevron-left'
    | 'chevron-right-circle'
    | 'chevron-right'
    | 'chevron-up-circle'
    | 'chevron-up'
    | 'circle-filled'
    | 'circle'
    | 'close'
    | 'clock'
    | 'coin-dollar'
    | 'edit'
    | 'export'
    | 'external-link'
    | 'eye'
    | 'facebook'
    | 'file-download'
    | 'file'
    | 'filter'
    | 'folder-archive'
    | 'folder'
    | 'globe'
    | 'heart'
    | 'home'
    | 'image'
    | 'import'
    | 'info'
    | 'instagram'
    | 'laptop'
    | 'light-bulb'
    | 'line-up'
    | 'linkedin'
    | 'list'
    | 'location'
    | 'lock-open'
    | 'lock'
    | 'login'
    | 'logout'
    | 'mail'
    | 'map'
    | 'map-pin'
    | 'maximize'
    | 'maximize-2'
    | 'megaphone'
    | 'menu'
    | 'minus'
    | 'mobile'
    | 'more'
    | 'message-square'
    | 'pause'
    | 'phone'
    | 'pinterest'
    | 'play-circle'
    | 'play-duotone'
    | 'play'
    | 'plus'
    | 'question-mark'
    | 'remove'
    | 'round-outline'
    | 'round-solid'
    | 'search'
    | 'send'
    | 'settings-adjust'
    | 'settings'
    | 'share'
    | 'shopping-cart'
    | 'square-checked'
    | 'square'
    | 'star'
    | 'time'
    | 'trash-can'
    | 'trophy'
    | 'twitter'
    | 'user-circle'
    | 'user'
    | 'warning'
    | 'x-circle'
    | 'x'
    | 'youtube'
    | 'floorplan'
    // Brand Icons
    | 'brand-icons/agreement-sign'
    | 'brand-icons/aircon'
    | 'brand-icons/art-and-craft-brushes'
    | 'brand-icons/art-and-craft-canvas'
    | 'brand-icons/balcony'
    | 'brand-icons/bath'
    | 'brand-icons/bbq'
    | 'brand-icons/bed'
    | 'brand-icons/billiards-gamesroom'
    | 'brand-icons/binoculars'
    | 'brand-icons/camp-caravan'
    | 'brand-icons/camping-tent'
    | 'brand-icons/car'
    | 'brand-icons/carer-foster-kindship'
    | 'brand-icons/carspace-carport'
    | 'brand-icons/chair'
    | 'brand-icons/church-candles'
    | 'brand-icons/cleaning-and-laundry'
    | 'brand-icons/community-large-house'
    | 'brand-icons/day-trips-bus-coach'
    | 'brand-icons/dementia-care-brain-heart'
    | 'brand-icons/direction-signs'
    | 'brand-icons/distance-85-km'
    | 'brand-icons/doctor-stethoscope'
    | 'brand-icons/early-learning-services'
    | 'brand-icons/employees-badge'
    | 'brand-icons/established-gardens-flower'
    | 'brand-icons/exercise-weight'
    | 'brand-icons/family-care'
    | 'brand-icons/family-daycare'
    | 'brand-icons/family-support-umbrella'
    | 'brand-icons/fishing-line-fish'
    | 'brand-icons/garage-house'
    | 'brand-icons/garden-maintenance-mower'
    | 'brand-icons/garden-modifications-pot-shovel'
    | 'brand-icons/golf-cart'
    | 'brand-icons/golf-flag'
    | 'brand-icons/government'
    | 'brand-icons/grocery-general-shopping'
    | 'brand-icons/hair-salon-scissors-comb'
    | 'brand-icons/hearts-family-support'
    | 'brand-icons/heating-sun'
    | 'brand-icons/home-care-mop-bucket'
    | 'brand-icons/home-maintenance-tools'
    | 'brand-icons/home-modifications'
    | 'brand-icons/home-services-cleaning'
    | 'brand-icons/housekeeping-clean-mop-bucket'
    | 'brand-icons/housing-services-welcome'
    | 'brand-icons/in-home-care'
    | 'brand-icons/industry-bodies-cogs'
    | 'brand-icons/investors-graph'
    | 'brand-icons/journey-path'
    | 'brand-icons/kitchen'
    | 'brand-icons/laundry-custom'
    | 'brand-icons/laundry-washing-machine'
    | 'brand-icons/library-books'
    | 'brand-icons/local-government'
    | 'brand-icons/lockup-storage-lock'
    | 'brand-icons/maintenance-services'
    | 'brand-icons/male-female-symbols'
    | 'brand-icons/manage-finances-checklist'
    | 'brand-icons/meal-prep-chopping-board'
    | 'brand-icons/meals-provided-klosh'
    | 'brand-icons/meals-provided-plate'
    | 'brand-icons/medical-care-medical-kit-doctor'
    | 'brand-icons/motocross-track-race-track'
    | 'brand-icons/multiple-homes'
    | 'brand-icons/next-step-shoe'
    | 'brand-icons/overseas-aeroplane'
    | 'brand-icons/palliative-care'
    | 'brand-icons/park-trees'
    | 'brand-icons/pastoral-support-church'
    | 'brand-icons/pet-friendly-animals'
    | 'brand-icons/picnic-basket'
    | 'brand-icons/pool-swim'
    | 'brand-icons/private-sector-apartment'
    | 'brand-icons/property-inspection'
    | 'brand-icons/registered-nurse'
    | 'brand-icons/renovated-paint-roller'
    | 'brand-icons/residential-care-home'
    | 'brand-icons/residential-slippers'
    | 'brand-icons/respite-care-tea-heart'
    | 'brand-icons/respite-care-tea'
    | 'brand-icons/services-500-plus'
    | 'brand-icons/shopping-bags'
    | 'brand-icons/social-connections'
    | 'brand-icons/spacious-floorplan'
    | 'brand-icons/stakeholders-engagement'
    | 'brand-icons/support-and-development'
    | 'brand-icons/telephone-point-phone'
    | 'brand-icons/thriving-community'
    | 'brand-icons/time-clock'
    | 'brand-icons/veggie-garden-plant-shovel'
    | 'brand-icons/wardrobe'
    | 'brand-icons/windows'
    | 'brand-icons/wine-glass'
    | 'brand-icons/youth-lego-bricks'
    | 'brand-icons/opened-mail';

export type IconSVG = React.FunctionComponent<React.SVGProps<SVGSVGElement>>;

export const allIconComponents: Record<IconString, IconSVG> = {
    adjust: Adjust,
    'alert-circle': AlertCircle,
    'arrow-down-circle': ArrowDownCircle,
    'arrow-down': ArrowDown,
    'arrow-left-circle': ArrowLeftCircle,
    'arrow-left': ArrowLeft,
    'arrow-right-circle': ArrowRightCircle,
    'arrow-right': ArrowRight,
    'arrow-up-circle': ArrowUpCircle,
    'arrow-up': ArrowUp,
    at: At,
    'bank-card': BankCard,
    bank: Bank,
    bath: BathBasic,
    banknote: Banknote,
    bell: Bell,
    bed: BedBasic,
    bookmark: Bookmark,
    calendar: Calendar,
    camera: Camera,
    car: CarBasic,
    'chat-text': ChatText,
    'check-circle': CheckCircle,
    'chevron-double-down': ChevronDoubleDown,
    'chevron-double-left': ChevronDoubleLeft,
    'chevron-double-right': ChevronDoubleRight,
    'chevron-double-up': ChevronDoubleUp,
    'chevron-down-circle': ChevronDownCircle,
    'chevron-down': ChevronDown,
    'chevron-left-circle': ChevronLeftCircle,
    'chevron-left': ChevronLeft,
    'chevron-right-circle': ChevronRightCircle,
    'chevron-right': ChevronRight,
    'chevron-up-circle': ChevronUpCircle,
    'chevron-up': ChevronUp,
    'circle-filled': CircleFilled,
    circle: Circle,
    close: Close,
    clock: Clock,
    'coin-dollar': CoinDollar,
    edit: Edit,
    export: Export,
    'external-link': ExternalLink,
    eye: Eye,
    facebook: Facebook,
    'file-download': FileDownload,
    file: File,
    filter: Filter,
    'folder-archive': FolderArchive,
    folder: Folder,
    globe: Globe,
    heart: Heart,
    home: Home,
    image: Image,
    import: Import,
    info: Info,
    instagram: Instagram,
    laptop: Laptop,
    'light-bulb': LightBulb,
    'line-up': LineUp,
    linkedin: Linkedin,
    list: List,
    location: Location,
    'lock-open': LockOpen,
    lock: Lock,
    login: Login,
    logout: Logout,
    mail: Mail,
    map: Map,
    'map-pin': MapPin,
    maximize: Maximize,
    'maximize-2': Maximize2,
    megaphone: Megaphone,
    menu: Menu,
    minus: Minus,
    mobile: Mobile,
    'message-square': MessageSqaure,
    more: More,
    pause: Pause,
    phone: Phone,
    pinterest: Pinterest,
    'play-circle': PlayCircle,
    'play-duotone': PlayDuotone,
    play: Play,
    plus: Plus,
    'question-mark': QuestionMark,
    remove: Remove,
    'round-outline': RoundOutline,
    'round-solid': RoundSolid,
    search: Search,
    send: Send,
    'settings-adjust': SettingsAdjust,
    settings: Settings,
    share: Share,
    'shopping-cart': ShoppingCart,
    'square-checked': SquareChecked,
    square: Square,
    star: Star,
    time: Time,
    'trash-can': TrashCan,
    trophy: Trophy,
    twitter: Twitter,
    'user-circle': UserCircle,
    user: User,
    warning: Warning,
    'x-circle': XCircle,
    x: X,
    youtube: Youtube,
    floorplan: Floorplan,
    // Brand Icons
    'brand-icons/agreement-sign': AgreementSign,
    'brand-icons/aircon': Aircon,
    'brand-icons/art-and-craft-brushes': ArtAndCraftBrushes,
    'brand-icons/art-and-craft-canvas': ArtAndCraftCanvas,
    'brand-icons/balcony': Balcony,
    'brand-icons/bath': Bath,
    'brand-icons/bbq': Bbq,
    'brand-icons/bed': Bed,
    'brand-icons/billiards-gamesroom': BilliardsGamesroom,
    'brand-icons/binoculars': Binoculars,
    'brand-icons/camp-caravan': CampCaravan,
    'brand-icons/camping-tent': CampingTent,
    'brand-icons/car': Car,
    'brand-icons/carer-foster-kindship': CarerFosterKindship,
    'brand-icons/carspace-carport': CarspaceCarport,
    'brand-icons/chair': Chair,
    'brand-icons/church-candles': ChurchCandles,
    'brand-icons/cleaning-and-laundry': CleaningAndLaundry,
    'brand-icons/community-large-house': CommunityLargeHouse,
    'brand-icons/day-trips-bus-coach': DayTripsBusCoach,
    'brand-icons/dementia-care-brain-heart': DementiaCareBrainHeart,
    'brand-icons/direction-signs': DirectionSigns,
    'brand-icons/distance-85-km': Distance85km,
    'brand-icons/doctor-stethoscope': DoctorStethoscope,
    'brand-icons/early-learning-services': EarlyLearningServices,
    'brand-icons/employees-badge': EmployeesBadge,
    'brand-icons/established-gardens-flower': EstablishedGardensFlower,
    'brand-icons/exercise-weight': ExerciseWeight,
    'brand-icons/family-care': FamilyCare,
    'brand-icons/family-daycare': FamilyDaycare,
    'brand-icons/family-support-umbrella': FamilySupportUmbrella,
    'brand-icons/fishing-line-fish': FishingLineFish,
    'brand-icons/garage-house': GarageHouse,
    'brand-icons/garden-maintenance-mower': GardenMaintenanceMower,
    'brand-icons/garden-modifications-pot-shovel': GardenModificationsPotShovel,
    'brand-icons/golf-cart': GolfCart,
    'brand-icons/golf-flag': GolfFlag,
    'brand-icons/government': Government,
    'brand-icons/grocery-general-shopping': GroceryGeneralShopping,
    'brand-icons/hair-salon-scissors-comb': HairSalonScissorsComb,
    'brand-icons/hearts-family-support': HeartsFamilySupport,
    'brand-icons/heating-sun': HeatingSun,
    'brand-icons/home-care-mop-bucket': HomeCareMopBucket,
    'brand-icons/home-maintenance-tools': HomeMaintenanceTools,
    'brand-icons/home-modifications': HomeModifications,
    'brand-icons/home-services-cleaning': HomeServicesCleaning,
    'brand-icons/housekeeping-clean-mop-bucket': HousekeepingCleanMopBucket,
    'brand-icons/housing-services-welcome': HousingServicesWelcome,
    'brand-icons/in-home-care': InHomeCare,
    'brand-icons/industry-bodies-cogs': IndustryBodiesCogs,
    'brand-icons/investors-graph': InvestorsGraph,
    'brand-icons/journey-path': JourneyPath,
    'brand-icons/kitchen': Kitchen,
    'brand-icons/laundry-custom': LaundryCustom,
    'brand-icons/laundry-washing-machine': LaundryWashingMachine,
    'brand-icons/library-books': LibraryBooks,
    'brand-icons/local-government': LocalGovernment,
    'brand-icons/lockup-storage-lock': LockupStorageLock,
    'brand-icons/maintenance-services': MaintenanceServices,
    'brand-icons/male-female-symbols': MaleFemaleSymbols,
    'brand-icons/manage-finances-checklist': ManageFinancesChecklist,
    'brand-icons/meal-prep-chopping-board': MealPrepChoppingBoard,
    'brand-icons/meals-provided-klosh': MealsProvidedKlosh,
    'brand-icons/meals-provided-plate': MealsProvidedPlate,
    'brand-icons/medical-care-medical-kit-doctor': MedicalCareMedicalKitDoctor,
    'brand-icons/motocross-track-race-track': MotocrossTrackRaceTrack,
    'brand-icons/multiple-homes': MultipleHomes,
    'brand-icons/next-step-shoe': NextStepShoe,
    'brand-icons/overseas-aeroplane': OverseasAeroplane,
    'brand-icons/palliative-care': PalliativeCare,
    'brand-icons/park-trees': ParkTrees,
    'brand-icons/pastoral-support-church': PastoralSupportChurch,
    'brand-icons/pet-friendly-animals': PetFriendlyAnimals,
    'brand-icons/picnic-basket': PicnicBasket,
    'brand-icons/pool-swim': PoolSwim,
    'brand-icons/private-sector-apartment': PrivateSectorApartment,
    'brand-icons/property-inspection': PropertyInspection,
    'brand-icons/registered-nurse': RegisteredNurse,
    'brand-icons/renovated-paint-roller': RenovatedPaintRoller,
    'brand-icons/residential-care-home': ResidentialCareHome,
    'brand-icons/residential-slippers': ResidentialSlippers,
    'brand-icons/respite-care-tea-heart': RespiteCareTeaHeart,
    'brand-icons/respite-care-tea': RespiteCareTea,
    'brand-icons/services-500-plus': Services500Plus,
    'brand-icons/shopping-bags': ShoppingBags,
    'brand-icons/social-connections': SocialConnections,
    'brand-icons/spacious-floorplan': SpaciousFloorplan,
    'brand-icons/stakeholders-engagement': StakeholdersEngagement,
    'brand-icons/support-and-development': SupportAndDevelopment,
    'brand-icons/telephone-point-phone': TelephonePointPhone,
    'brand-icons/thriving-community': ThrivingCommunity,
    'brand-icons/time-clock': TimeClock,
    'brand-icons/veggie-garden-plant-shovel': VeggieGardenPlantShovel,
    'brand-icons/wardrobe': Wardrobe,
    'brand-icons/windows': Windows,
    'brand-icons/wine-glass': WineGlass,
    'brand-icons/youth-lego-bricks': YouthLegoBricks,
    'brand-icons/opened-mail': OpenedMail
};

interface IconProps {
    icon: IconString | string;
    className?: string;
    // eslint-disable-next-line no-unused-vars
    onClick?: (event: ClickOrPressEvent) => void;
}

const Icon = (props: IconProps) => {
    const { icon, className, onClick } = props;
    const iconName = icon.includes('brand-icons/') ? icon as IconString : kebabCase(icon) as IconString;
    const SpecificIcon = allIconComponents[iconName];

    if (!SpecificIcon) return null;

    const isClickableClass = onClick ? 'svg-icon-clickable' : '';

    const iconWrapperClass = `svg-icon-wrapper ${isClickableClass} ${className ? className : ''}`;

    return (
        <div className={iconWrapperClass}>
            <SpecificIcon onClick={onClick} className="svg-icon" />
        </div>
    );
};

export default Icon;
